import axios from 'axios';
import { getApiClientFront, getApiClientBack } from "../api/api";

  // const apiUrlMap = {
  //   // "pruebabopiweb.oepm.es": "http://pruebaconsultas5.oepm.es:5000",
  //   // "pruebabopiweb.oepm.es": "https://pruebabopiweb.oepm.es/apibopiweb",
  //   "pruebasede.oepm.gob.es": "https://pruebasede.oepm.gob.es/bopi/apibopiweb",
  //   "prebopiweb.oepm.es": "https://prebopiweb.oepm.es/apibopiweb",
  //   "bopiweb.oepm.es": "https://bopiweb.oepm.es/apibopiweb",
  
  //   "defaultApiUrl": "Error",
  //   "localhost": "http://localhost:5000",    
  // };
  
  // const api = axios.create({
  //   // baseURL: "http://localhost:8080/BopiWeb/"    
  //   baseURL: apiUrlMap[window.location.hostname] || apiUrlMap["defaultApiUrl"],
  // })

  export const getDetalleMarcadas = async (idPublicacion, tomo) => {
    const api = await getApiClientBack();
    const response = await api.post('/detalleMarcadas', { ids: idPublicacion, tomo }, {
      headers: { 'Content-Type': 'application/json' }
    });
  
    return response.data;
  };
  